export const GroupsContactsActionTypes = {
  API_RESPONSE_SUCCESS: '@@groups-contacts/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@groups-contacts/API_RESPONSE_ERROR',

  GET_GROUPS_CONTACTS: '@@groups-contacts/GET_GROUPS_CONTACTS',
  LIST_GROUPS_CONTACTS: '@@groups-contacts/LIST_GROUPS_CONTACTS',
  ADD_GROUPS_CONTACTS: '@@groups-contacts/ADD_GROUPS_CONTACTS',
  UPDATE_GROUPS_CONTACTS: '@@groups-contacts/UPDATE_GROUPS_CONTACTS',
  DELETE_GROUPS_CONTACTS: '@@groups-contacts/DELETE_GROUPS_CONTACTS',

  RESET: '@@groups-contacts/RESET'
}
